var _a, _b, _c;
import { BoundingVolumeType } from './BoundingVolumeType';
import { BoundingBox } from './BoundingBox';
import { BoundingSphere } from './BoundingSphere';
import { NullBounds } from './NullBounds';
var BoundingVolumePool = /** @class */ (function () {
    function BoundingVolumePool(picker, boundingVolumeType) {
        this._boundingVolumePool = new Object();
        this._picker = picker;
        this._strokeFlag = BoundingVolumePool._strokeDict[boundingVolumeType];
        this._fastFlag = BoundingVolumePool._fastDict[boundingVolumeType];
        this._boundingVolumeClass = BoundingVolumePool._boundsDict[boundingVolumeType];
    }
    Object.defineProperty(BoundingVolumePool.prototype, "picker", {
        get: function () {
            return this._picker;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BoundingVolumePool.prototype, "strokeFlag", {
        get: function () {
            return this._strokeFlag;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BoundingVolumePool.prototype, "fastFlag", {
        get: function () {
            return this._fastFlag;
        },
        enumerable: true,
        configurable: true
    });
    BoundingVolumePool.prototype.getAbstraction = function (entity) {
        var id = entity ? entity.id : -1;
        return (this._boundingVolumePool[id] || (this._boundingVolumePool[id] = new this._boundingVolumeClass(entity, this)));
    };
    BoundingVolumePool.prototype.clearAbstraction = function (entity) {
        delete this._boundingVolumePool[entity ? entity.id : -1];
    };
    BoundingVolumePool.prototype.dispose = function () {
        for (var key in this._boundingVolumePool)
            this._boundingVolumePool[key].onClear(null);
    };
    BoundingVolumePool._strokeDict = (_a = {},
        _a[BoundingVolumeType.BOX] = false,
        _a[BoundingVolumeType.BOX_FAST] = false,
        _a[BoundingVolumeType.BOX_BOUNDS] = true,
        _a[BoundingVolumeType.BOX_BOUNDS_FAST] = true,
        _a[BoundingVolumeType.SPHERE] = false,
        _a[BoundingVolumeType.SPHERE_FAST] = false,
        _a[BoundingVolumeType.SPHERE_BOUNDS] = true,
        _a[BoundingVolumeType.SPHERE_FAST] = true,
        _a[BoundingVolumeType.NULL] = false,
        _a);
    BoundingVolumePool._fastDict = (_b = {},
        _b[BoundingVolumeType.BOX] = false,
        _b[BoundingVolumeType.BOX_FAST] = true,
        _b[BoundingVolumeType.BOX_BOUNDS] = false,
        _b[BoundingVolumeType.BOX_BOUNDS_FAST] = true,
        _b[BoundingVolumeType.SPHERE] = false,
        _b[BoundingVolumeType.SPHERE_FAST] = true,
        _b[BoundingVolumeType.SPHERE_BOUNDS] = false,
        _b[BoundingVolumeType.SPHERE_FAST] = true,
        _b[BoundingVolumeType.NULL] = false,
        _b);
    BoundingVolumePool._boundsDict = (_c = {},
        _c[BoundingVolumeType.BOX] = BoundingBox,
        _c[BoundingVolumeType.BOX_FAST] = BoundingBox,
        _c[BoundingVolumeType.BOX_BOUNDS] = BoundingBox,
        _c[BoundingVolumeType.BOX_BOUNDS_FAST] = BoundingBox,
        _c[BoundingVolumeType.SPHERE] = BoundingSphere,
        _c[BoundingVolumeType.SPHERE_FAST] = BoundingSphere,
        _c[BoundingVolumeType.SPHERE_BOUNDS] = BoundingSphere,
        _c[BoundingVolumeType.SPHERE_FAST] = BoundingSphere,
        _c[BoundingVolumeType.NULL] = NullBounds,
        _c);
    return BoundingVolumePool;
}());
export { BoundingVolumePool };
